module.exports = __webpack_public_path__ + "img/interests.5e038ba6.svg";